'use client';

import { createContext, useContext } from 'react';

export type SpokeType = 'media-center' | 'neighborhood' | 'units' | 'cost-and-fees';

type SpokeNavigationContextValue = {
  activeSpoke: SpokeType | null;
  openSpoke: (type: SpokeType, config?: unknown) => void;
  closeSpoke: () => void;
  isMobile: boolean;
};

export const SpokeNavigationContext = createContext<SpokeNavigationContextValue | null>(null);

export const useSpokeNavigation = () => {
  const context = useContext(SpokeNavigationContext);
  if (!context) {
    throw new Error('useSpokeNavigation must be used within a SpokeNavigationProvider');
  }
  return context;
};
